import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppDispatch } from '../../store/store';
import { searchCompanies } from '../../store/thunks/companiesThunk';
import {
  fetchTranslators,
  searchTranslators,
} from '../../store/thunks/translatorsThunk';
import style from './ControlPanel.module.css';
import SearchInput from './SearchInput/SearchInput';
import TranslatorForm from './TranslatorForm/TranslatorForm';
import PlusLogo from './icons/Plus';
import ExcelLogo from './icons/ExcelLogo';

interface ControlPanelProps {
  setIsSearching: (isSearching: boolean) => void;
  onSearch: (query: string) => void;
  onAddCompany?: () => void;
  onAddAdmiration?: () => void;
  onExport?: () => void;
  isExporting?: boolean;
}

const ControlPanel: React.FC<ControlPanelProps> = ({
  setIsSearching,
  onSearch,
  onAddCompany,
  onAddAdmiration,
  onExport,
  isExporting,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const location = useLocation();
  const [isHovered, setIsHovered] = useState<boolean>(false);
  const [isFormVisible, setIsFormVisible] = useState<boolean>(false);
  const [query, setQuery] = useState<string>('');

  useEffect(() => {
    const handler = setTimeout(() => {
      if (query.length >= 2) {
        setIsSearching(true);
        if (location.pathname === '/customer') {
          // dispatch(fetchClients(1, 12, 'asc', query));
        } else if (location.pathname === '/translators') {
          dispatch(searchTranslators(query));
        } else if (location.pathname === '/company') {
          dispatch(searchCompanies(query));
        }
      } else if (query.length === 0) {
        setIsSearching(false);
        setQuery('');
      }
    }, 1000);

    return () => {
      clearTimeout(handler);
    };
  }, [query, dispatch, setIsSearching, location.pathname]);

  const handleSearchChange = (query: string) => {
    setQuery(query);
    onSearch(query);
  };

  const handleClearSearch = () => {
    setQuery('');
    setIsSearching(false);
    onSearch('');
    if (location.pathname === '/translators') {
      dispatch(fetchTranslators(0, 20, 'ASC'));
    }
  };

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
  };

  return (
    <div className={style.panel_wrap}>
      <SearchInput
        query={query}
        onChange={handleSearchChange}
        onClear={handleClearSearch}
      />
      <div className={style.container_button}>
        {(location.pathname === '/customer' ||
          location.pathname === '/company') &&
          onExport && (
            <button
              className={style.excelButton}
              onClick={onExport}
              disabled={isExporting}
              title="Завантажити перелік у Excel"
            >
              <ExcelLogo />
              {isExporting ? 'Готуємо…' : 'Excel'}
            </button>
          )}
        {location.pathname === '/company' && onAddCompany && (
          <button onClick={onAddCompany}>
            <PlusLogo />
            Додати компанію
          </button>
        )}
        {location.pathname === '/translators' && (
          <button
            className={isHovered ? style.hovered : ''}
            onClick={toggleFormVisibility}
          >
            <PlusLogo />
            Додати перекладача
          </button>
        )}
        {location.pathname === '/administrator' && (
          <button onClick={onAddAdmiration}>
            <PlusLogo />
            Додати адміністратора
          </button>
        )}
      </div>
      {isFormVisible && <TranslatorForm onClose={toggleFormVisibility} />}
    </div>
  );
};

export default ControlPanel;
